import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const user = localStorage.getItem("linko_admin");

  // If the user is authenticated, redirect to a protected page
  if (user) {
    return <Navigate to="/user-admin" />;
  }

  // If not authenticated, allow access to the public page (e.g., login)
  return children;
};

export default PublicRoute;
